/**
 * Created by Litong on 17/8/23.
 */

// 版本
const apiVersion = '/v2'

// 自定义权限编码
var G_CUSTOM_AUTH_CODE = {
  preview: 1025,
  download: 1028,
  upload: 1026,
  create: 1056,
  delivery: 1048,
  'delete': 1088,
  rename: 1152,
  copy: 1536,
  move: 1280,
  comment: 3072
}
// 标准权限掩码
var G_STANDARD_AUTH_CODE = {preview: 3073, upload: 3130, download: 3613, uploaddownload: 3647, edit: 4095, deny: 0}
// // 标准权限拒绝掩码
var G_STANDARD_AUTH_CODE_DENY = {preview: 0, upload: 0, download: 0, uploaddownload: 0, edit: 0, deny: 4095}
// // 标准权限掩码(文件共享用)
var G_STANDARD_AUTH_CODE_FILE = {preview: 3073, download: 3613, edit: 3615, deny: 0}
// 标准权限掩码ID
var G_STANDARD_AUTH_CODE_ID = {preview: 3001, upload: 3002, download: 3003, uploaddownload: 3004, edit: 3005, deny: 3006}
// // 标准权限拒绝掩码(文件共享用)
var G_STANDARD_AUTH_CODE_DENY_FILE = {preview: 0, download: 0, edit: 0, deny: 3615}
// 权限名称
var G_AUTH_TITLE = {
  preview: '预览',
  upload: '上传',
  download: '下载',
  uploaddownload: '上传/下载',
  edit: '编辑',
  deny: '禁止访问',
  custom: '自定义'
}

import store from '../../store/index'

export function resolvePath (path, flag) {
  if (path === '/') {
    return {name: '', type: ''}
  }
  var regName = /\/([^/]+)$/
  var exSuffix = /\.([^.]+)$/
  var name, suffix
  if (!path) return ''
  name = path.match(regName)
  if (!flag && name[1]) {
    suffix = name[1].match(exSuffix) || ['', '']
  }
  return {
    name: name[1] || '',
    type: flag ? 'folder' : suffix[1].toLowerCase()
  }
}

export function formatBytes (baseNumber, fixed) {
  var sizeUnits = [1099511627776, 1073741824, 1048576, 1024, 1]
  var sizeUnitLabels = ['TB', 'GB', 'MB', 'KB', 'B']
  return _formatUnits(baseNumber, sizeUnits, sizeUnitLabels, true, fixed)
}

function _formatUnits (baseNumber, unitDivisors, unitLabels, singleFractional, fixed) {
  var i, unit, unitDivisor, unitLabel
  if (typeof fixed !== 'number') {
    fixed = 2
  }
  if (baseNumber === 0) {
    return '0 ' + unitLabels[unitLabels.length - 1]
  }

  if (singleFractional) {
    unit = baseNumber
    unitLabel = unitLabels.length >= unitDivisors.length ? unitLabels[unitDivisors.length - 1] : ''
    for (i = 0; i < unitDivisors.length; i++) {
      if (baseNumber >= unitDivisors[i]) {
        unit = (baseNumber / unitDivisors[i]).toFixed(fixed)
        unitLabel = unitLabels.length >= i ? ' ' + unitLabels[i] : ''
        break
      }
    }

    return unit + unitLabel
  } else {
    var formattedStrings = []
    var remainder = baseNumber

    for (i = 0; i < unitDivisors.length; i++) {
      unitDivisor = unitDivisors[i]
      unitLabel = unitLabels.length > i ? ' ' + unitLabels[i] : ''

      unit = remainder / unitDivisor
      if (i < unitDivisors.length - 1) {
        unit = Math.floor(unit)
      } else {
        unit = unit.toFixed(0)
      }
      if (unit > 0) {
        remainder = remainder % unitDivisor
        formattedStrings.push(unit + unitLabel)
      }
    }

    return formattedStrings.join(' ')
  }
}

export function formatDate (dateObj, fmt) {
  var year, month, date, hours, minutes, seconds

  if (!dateObj) return

  if (Object.prototype.toString.call(dateObj) === '[object Date]') {
    year = dateObj.getFullYear()
    month = dateObj.getMonth() + 1
    date = dateObj.getDate()
    hours = dateObj.getHours()
    minutes = dateObj.getMinutes()
    seconds = dateObj.getSeconds()
  } else {
    var regexp = /([\d]{4})-([\d]{2})-([\d]{2})T([\d]{2}):([\d]{2}):([\d]{2})(?:\+([\d]{2}):([\d]{2}))?/
    var d = regexp.exec(dateObj)
    if (!d) return
    year = d[1]
    month = d[2]
    date = d[3]
    hours = d[4]
    minutes = d[5]
    seconds = d[6]
  }
  var o = {
    'M+': +month, // 月份
    'd+': +date, // 日
    'h+': +hours, // 小时
    'm+': +minutes, // 分
    's+': +seconds, // 秒
    'q+': Math.floor((+month + 3) / 3)
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (year + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
/**
 * utc转换日期
 * @param utc
 * @returns String
 */
export function utc2date (utc) {
  let datetime = new Date(utc)
  let year = datetime.getFullYear()
  let month = (datetime.getMonth() + 1 < 10) ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1
  let day = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
  let hour = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
  let min = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes()
  let sec = datetime.getSeconds() < 10 ? '0' + datetime.getSeconds() : datetime.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec
}

/**
 * 是否为音视频
 * @param mime
 * @returns {boolean}
 */
export function isVideo (mime) {
  return /\.avi|f4v|mpg|wma|mp4|flv|wmv|mov|3gp|rmvb|mkv|asf|264|ts|mts|vob|m4v/.test(mime)
}

/**
 * 是否为音频
 * @param mime
 * @returns {boolean}
 */
export function isAudio (mime) {
  if (/\.rar/.test(mime)) {
    return false
  }
  return /\.mp3|aac|ape|flac|wma|ra|wav|mid|vqf|aif|au|dsp|cmf|cda|mod|iff|m3u|m4a|mpa|aiff|ac3|mur|mp2|amr/.test(mime)
}

/**
 * 是否为文档
 * @param mime
 * @returns {boolean}
 */
export function isDocs (mime) {
  return /\.doc|dps|wps|et|ppt|txt|xls|docx|pptx|xlsx/.test(mime)
}

/**
 * 是否为pdf
 * @param mime
 * @returns {boolean}
 */
export function isPdf (mime) {
  return /\.pdf/.test(mime)
}

export function getMyEncodeURI (path) {
  path = encodeURI(path).replace(/&/g, '%26').replace(/#/g, '%23').replace(/\+/g, '%2B')
  return path
}

export function getPreviewUrl (item) {
  var type = `doc`
  if (isVideo(item.mime_type) || isAudio(item.mime_type)) {
    type = `av`
  }
  var uri = '/v2/preview_router?type=' + type + '&root=databox&path=' + getMyEncodeURI(item.path) + '&path_type=' + item.path_type + '&from' + item.from + '&neid=' + item.neid + '&'
  uri += 'rev=' + item.rev
  uri = uri.replace(`//`, `/`)
  return uri
}

export function getSession () {
  return store.state.userInfo['X-LENOVO-SESS-ID']
}

export function getCSSActionByCode (code) {
  var rs = ''
  var returnData = {}
  for (var o in G_CUSTOM_AUTH_CODE) {
    if ((code & G_CUSTOM_AUTH_CODE[o]) === G_CUSTOM_AUTH_CODE[o]) {
      if (rs !== '') {
        rs += ':' + o
      } else {
        rs = o
      }
    }
  }
  returnData.authCSS = rs
  for (var i in G_STANDARD_AUTH_CODE) {
    if (code === G_STANDARD_AUTH_CODE[i]) {
      returnData.authType = i
    }
    if (!returnData.authType) {
      returnData.authType = 'custom'
    }
  }
  return returnData
}

/**
 * 根据权限的掩码判断文件夹是否是标准权限
 */
export function getAuthTypeByAuthMask (allowedMask, deniedMask) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (allowedMask === G_STANDARD_AUTH_CODE[o] && deniedMask === G_STANDARD_AUTH_CODE_DENY[o]) {
      return {'isStandard': true, 'authName': o}
    }
  }
  return {'isStandard': false, 'authName': 'custom'}
}

/**
 * 根据权限的掩码判断文件是否是标准权限
 */
export function getFileAuthTypeByAuthMask (allowedMask, deniedMask) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (allowedMask === G_STANDARD_AUTH_CODE_FILE[o] && deniedMask === G_STANDARD_AUTH_CODE_DENY_FILE[o]) {
      return {'isStandard': true, 'authName': o}
    }
  }
  return {'isStandard': false, 'authName': 'custom'}
}

/**
 * 根据权限的掩码判断文件是否是标准权限
 */
export function getAuthNameByAccessMode (accessMode) {
  for (var o in G_STANDARD_AUTH_CODE) {
    if (accessMode === G_STANDARD_AUTH_CODE[o]) {
      return {'isStandard': true, 'authName': G_AUTH_TITLE[o]}
    }
  }
  return {'isStandard': false, 'authName': 'custom'}
}

export function getPrivatePrivilege (cssAction) {
  return {
    canPreview: /preview|edit|download\b|download-\w+/.test(cssAction),
    canUpload: /upload|edit/.test(cssAction),
    canDownload: /download|edit/.test(cssAction),
    canLink: /delivery|edit/.test(cssAction),
    canCreate: /create|edit|upload\b|upload-\w+/.test(cssAction),
    canDelete: /delete|edit/.test(cssAction),
    canRename: /rename|edit/.test(cssAction),
    canMove: /move|edit/.test(cssAction),
    canCopy: /copy|download\b|download-\w+|edit/.test(cssAction)
  }
}
/**
 * 获取所有的权限名称
 * @param code
 */
export function getAllAuthName (code) {
  console.log(code)
  if (isNaN(code)) {
    return code
  }
  let rs = ''
  let key = ''
  for (let o in G_STANDARD_AUTH_CODE_ID) {
    if (G_STANDARD_AUTH_CODE_ID[o] === parseInt(code)) {
      key = o
      break
    }
  }
  rs = G_AUTH_TITLE[key]
  if (!rs) {
    return '自定义'
  }
  return rs
}

/**
 * 文件是否能预览
 */
export function canPreview (mime) {
  if (!mime) {
    return false
  }
  // ZH Bug #39987.diff后缀文件不应该显示预览按钮
  if (/\.diff/.test(mime)) {
    return false
  }
  return /\.doc|dps|wps|et|pdf|ppt|xls|docx|vsdx|pptx|xlsx|png|jpeg|jpg|gif|JPEG|JPG|GIF|pic|word|excel|mp4|wma|mp3|docx|avi|f4v|mpg|flv|wmv|mov|3gp|rmvb|mkv|asf|264|ts|mts|vob|wav|m4v|ape|flac|aac/.test(mime)
}

export function typeIcon (typeIcon) {
  var ImgType = typeIcon
  var jar = {
    'folder_team': 'folder_team',
    'folder_share': 'folder_share',
    'folder': 'folder',
    'doc': 'word',
    'docx': 'word',
    'wps': 'word',
    'rtf': 'word',
    'txt': 'text',
    'jpg': 'pic',
    'JPG': 'pic',
    'jpeg': 'pic',
    'JPEG': 'pic',
    'png': 'pic',
    'BMP': 'pic',
    'bmp': 'pic',
    'gif': 'pic',
    'GIF': 'pic',
    'tiff': 'pic',
    'pcx': 'pic',
    'thm': 'pic',
    'yuv': 'pic',
    'pps': 'ppt',
    'dps': 'ppt',
    'ppsx': 'ppt',
    'ppt': 'ppt',
    'pptx': 'ppt',
    'xls': 'excel',
    'xlsx': 'excel',
    'et': 'excel',
    'csv': 'excel',
    'lock': 'lock',
    'pct': 'pdf',
    'pdf': 'pdf',
    'pmd': 'pdf',
    'mp3': 'music',
    'aac': 'music',
    'flac': 'music',
    'ape': 'music',
    'wma': 'music',
    'ra': 'music',
    'wav': 'music',
    'mid': 'music',
    'vqf': 'music',
    'aif': 'music',
    'au': 'music',
    'dsp': 'music',
    'cmf': 'music',
    'cda': 'music',
    'mod': 'music',
    'iff': 'music',
    'm3u': 'music',
    'm4a': 'music',
    'mpa': 'music',
    'aiff': 'music',
    'ac3': 'music',
    'mur': 'music',
    'mp2': 'music',
    'amr': 'music',
    'avi': 'video',
    'mov': 'video',
    'mpg': 'video',
    'mp4': 'video',
    'xv': 'video',
    '3gp': 'video',
    'divx': 'video',
    'rm': 'video',
    'rmvb': 'video',
    'asf': 'video',
    'wmv': 'video',
    'vob': 'video',
    'mkv': 'video',
    'dat': 'video',
    '264': 'video',
    'flv': 'video',
    '3g2': 'video',
    'asx': 'video',
    'f4v': 'video',
    'h.264': 'video',
    'ts': 'video',
    'mts': 'video',
    'm4v': 'video',
    'exe': 'exe',
    'rar': 'zip',
    'zip': 'zip',
    'zipx': 'zip',
    '7z': 'zip',
    'cab': 'zip',
    'arj': 'zip',
    'jar': 'zip',
    'lzh': 'zip',
    'bin': 'zip',
    'deb': 'zip',
    'gz': 'zip',
    'rpm': 'zip',
    'sit': 'zip',
    'sitx': 'zip',
    'tar': 'zip',
    'cad': 'cad',
    'dxf': 'cad',
    'psd': 'ps',
    'ai': 'ai',
    'dw': 'dw',
    'fil': 'fl',
    'id': 'id',
    'ae': 'ae',
    '3d': '3d',
    'eps': 'svg',
    'svg': 'svg',
    'cdr': 'svg',
    'pages': 'other',
    'log': 'other',
    'msg': 'other',
    'xps': 'other',
    'chm': 'other',
    'pdg': 'other',
    'key': 'other',
    'efx': 'other',
    'sdf': 'other',
    'vcf': 'other',
    'wks': 'other',
    'munbers': 'other',
    '3dm': 'other',
    'diff': 'other',
    'max': 'other',
    'com': 'other',
    'bat': 'other',
    'scr': 'other',
    'lib': 'other',
    'app': 'other',
    'cgi': 'other',
    'gadget': 'other',
    'vb': 'other',
    'wsf': 'other',
    'accdb': 'other',
    'db': 'other',
    'dbf': 'other',
    'mdb': 'other',
    'pdb': 'other',
    'sql': 'other',
    'cpl': 'setting',
    'cur': 'setting',
    'dll': 'setting',
    'dmp': 'setting',
    'drv': 'setting',
    'lnk': 'setting',
    'sys': 'setting',
    'cfg': 'setting',
    'ini': 'setting',
    'keychain': 'setting',
    'prf': 'setting',
    'c': 'cpp',
    'class': 'cpp',
    'cpp': 'cpp',
    'cs': 'cpp',
    'dtd': 'cpp',
    'fla': 'cpp',
    'java': 'cpp',
    'm': 'cpp',
    'pl': 'cpp',
    'py': 'cpp',
    'html': 'html',
    'htm': 'html',
    'xhtml': 'html',
    'php': 'html',
    'css': 'html',
    'js': 'html',
    'xml': 'html',
    'asp': 'html',
    'cer': 'html',
    'rss': 'html',
    'ttf': 'font',
    'fnt': 'font',
    'otf': 'font',
    'fon': 'font',
    'dmg': 'iso',
    'toast': 'iso',
    'vcd': 'iso',
    'iso': 'iso',
    'apk': 'apk',
    'dwg': 'dwg'
  }
  var Extension
  for (var o in jar) {
    if (ImgType === o) {
      Extension = jar[o]
    }
  }
  if (Extension === undefined) {
    Extension = 'other'
  }
  typeIcon = Extension
  return typeIcon
}

export function getQueryStringByName (name) {
  var result = location.search.match(new RegExp(`[?&]` + name + `=([^&]+)`, `i`))
  if (result == null || result.length < 1) {
    return ''
  }
  return result[1]
}

export function getUserId () {
  return store.state.userInfo['user_id']
}

export function getSessionId () {
  return store.state.userInfo['X-LENOVO-SESS-ID']
}

export function getApiVersion () {
  return apiVersion
}

export function revertHtml (str, reg) {
  return str ? str.replace(reg || /[&<">]/g, function (m) {
    return {
      '<': '&lt;',
      '&': '&amp;',
      '"': '&quot;',
      '>': '&gt;'
    }[m]
  }) : ''
}

/**
 * 是否有可评论权限
 * @param code
 * @returns {boolean}
 */
export function canComment (code) {
  if ((code & G_CUSTOM_AUTH_CODE['comment']) === G_CUSTOM_AUTH_CODE['comment']) {
    return true
  }
  return false
}

export function validFilename (filename) {
  let rs = ''
  var reg = /[/:*?？、"<>|\\]/
  var reg1 = /^[.]/
  if (reg.test(filename)) {
    rs = '名称不能包括下列任何字符 : &#92 /:*?？、"<>|'
  }
  if (reg1.test(filename)) {
    rs = '名称不能以.开头'
  }
  if (filename === '') {
    rs = '名称不能为空'
  }
  return rs
}
export function revisionOp (operator) {
  var op = {
    create: '创建',
    restore: '恢复',
    undelete: '还原',
    update: '更新',
    rename: '重命名',
    move: '移动',
    delete: '删除'
  }
  return op[operator]
}
export function setCookie (name, value) {
  var cookieString = name + '=' + value
  document.cookie = cookieString
}

export function getCookie (name) {
  let sessionid = ''
  var arrstr = document.cookie.split('; ')
  for (var i = 0; i < arrstr.length; i++) {
    var temp = arrstr[i].split('=')
    if (temp[0] === name) {
      sessionid = temp[1]
    }
  }
  return sessionid
}

export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=-1'
  }
}



// WEBPACK FOOTER //
// ./src/common/js/util.js